export default __webpack_public_path__ + "static/l3-f54fab087c07195bc97bff9eecafb3f8.png";